document.addEventListener('DOMContentLoaded', () => {
  const prevArrow =
    '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="sun-protection-details-prev-${index}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="sun-protection-details-prev-${index}">Prev Item</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>';
  const nextArrow =
    '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="sun-protection-details-next-${index}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="sun-protection-details-next-${index}">Next Item</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>';

  const getPageCount = (slideCount, slidesToScroll) => {
    if (!slideCount || !slidesToScroll) return 0;
    return Math.ceil(slideCount / slidesToScroll);
  };

  const getPageFromSlide = (currentSlide, slidesToScroll) => {
    return Math.floor(currentSlide / slidesToScroll) + 1;
  };

  const whenSlickReady = (callback) => {
    if (window.jQuery?.fn?.slick) {
      callback();
      return;
    }

    const timer = window.setInterval(() => {
      if (window.jQuery?.fn?.slick) {
        window.clearInterval(timer);
        callback();
      }
    }, 50);

    window.setTimeout(() => window.clearInterval(timer), 5000);
  };

  whenSlickReady(() => {
    document.querySelectorAll('.sun-protection-details').forEach((section) => {
      const slider = section.querySelector('.sun-protection-details__slider');
      if (!slider || typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return;

      const $slider = window.jQuery(slider);
      const slideCount = $slider.children().length;
      if (!slideCount) return;

      const slidesToShow = Number(section.dataset.slidesToShow) || 2;
      const slidesPerView = Math.min(slidesToShow, slideCount);
      const slidesToScroll = slidesPerView;
      const currentEl = section.querySelector('.slider-counter--current');
      const totalEl = section.querySelector('.slider-counter--total');
      const dotsEl = section.querySelector('.sun-protection-details__dots');
      const arrowsEl = section.querySelector('.sun-protection-details__arrows');

      const updateCounter = (slick, currentSlide = 0) => {
        const scroll = slick?.options?.slidesToScroll || slidesToScroll;
        const page = getPageFromSlide(currentSlide, scroll);
        const pages = getPageCount(slideCount, scroll);

        if (currentEl) currentEl.textContent = page;
        if (totalEl) totalEl.textContent = pages;
      };

      const initSlider = () => {
        if ($slider.hasClass('slick-initialized')) return;

        $slider.slick({
          infinite: true,
          draggable: true,
          slidesToShow: slidesPerView,
          slidesToScroll,
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          dots: true,
          appendDots: dotsEl,
          responsive: [
            {
              breakpoint: 749,
              settings: {
                appendArrows: arrowsEl
              }
            }
          ]
        });

        $slider.on('init afterChange', (_event, slick, currentSlide) => {
          const index = typeof currentSlide === 'number' ? currentSlide : slick.currentSlide || 0;
          updateCounter(slick, index);
        });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                initSlider();
                observer.disconnect();
              }
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(section);
      } else {
        initSlider();
      }
    });
  });
});
